var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"banks"}},[_c('div',{staticClass:"container"},[_c('ul',_vm._l((_vm.banks),function(bank,key){return _c('li',{key:key,staticClass:"bank-item"},[_vm._v(_vm._s(bank.name))])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }